import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import DetailsForm from '../../../components/settings/details-form/details-form';
import useDetails from './hooks/use-details';

import cn from '../styles.module.css';

const PspDetails = () => {
  const {
    isLoading,
    errorList,
    control,
    errors,
    onSubmit,
    countries,
    fields,
    globalError,
    editIsLoading,
    isDirty,
  } = useDetails();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <DetailsForm
            control={control}
            errors={errors}
            onSubmit={onSubmit}
            countriesOptions={countries}
            sortCodeValue={fields.sortcode}
          >
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </DetailsForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspDetails;
